document.addEventListener('DOMContentLoaded', function() {

  var holidays = disabled_dates;
  var today = new Date();
  var UkTime = today.toLocaleString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
    timeZone: "Europe/London",
  });

  var formattedTime = parseInt(UkTime.split(":").join(""));

  $(function () {
    function XdisableDates(date) {
      var dt = $.datepicker.formatDate('dd-mm-yy', date);
      var noWeekend = jQuery.datepicker.noWeekends(date);
      return noWeekend[0] ? (($.inArray(dt, holidays) < 0) ? [true] : [false]) : noWeekend;
    }

    function disableDays() {
      var day = new Date();
      var today = day.getDay();
      if (today == 0 || today == 5) {
        return "+4";
      } else {
        return (formattedTime > 359) ? "+3" : "+4";
      }
    }

    var disabled = disableDays();

    $("#dn_date").datepicker({
      onSelect: function(date) {
        $('#dn_delivery_date_input').val(date);
      },
      beforeShow: function(input, inst) {
        $(this).attr("disabled", true);
      },
      beforeShowDay: XdisableDates,
      minDate: disabled,
      dateFormat: "dd-mm-yy",
    });

    // Auto-select first available date after init
    setTimeout(function () {
      var inst = $("#dn_date").datepicker("widget");
      var firstAvailableDate = $("#dn_date").datepicker("option", "minDate");
      $("#dn_date").datepicker("setDate", firstAvailableDate);
      $('#dn_delivery_date_input').val($("#dn_date").val());
    }, 200);

    var selectedDateInput = document.querySelector('#dn_delivery_date_input').value;
    if (selectedDateInput === "") {
      $('.ui-state-active').removeClass('ui-state-active');
    } else {
      console.log("Date Chosen");
    }
  });
});
